import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { FormsAppShell } from './layout/FormsAppShell';

export function FormsPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <FormsAppShell />
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
